export default "__VITE_ASSET__BmJAw8ah__"